import { useState } from 'react';
import { FiCheck, FiX, FiChevronDown, FiChevronRight } from 'react-icons/fi';
import ConfirmApproveModal from './ConfirmApproveModal';

export default function ProposedUpdateDiff({ proposal, onApprove, onReject }) {
  const [expanded, setExpanded] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const op = proposal.operation;
  const tableLbl = proposal.target_table;

  return (
    <div className="border border-gray-200 rounded p-2 mb-2 bg-white">
      <div className="flex items-center gap-2 cursor-pointer" onClick={() => setExpanded((x) => !x)}>
        {expanded ? <FiChevronDown className="h-3.5 w-3.5" /> : <FiChevronRight className="h-3.5 w-3.5" />}
        <span className={`px-1.5 py-0.5 rounded text-[10px] font-semibold ${
          op === 'INSERT' ? 'bg-green-100 text-green-800' : 'bg-orange-100 text-orange-800'
        }`}>{op}</span>
        <span className="text-[11px] font-mono text-gray-700">{tableLbl}</span>
        <span className="text-[10px] text-gray-500 truncate flex-1">{proposal.diff_preview}</span>
      </div>
      {expanded && (
        <div className="mt-2 pl-5 text-[10px] grid grid-cols-2 gap-2">
          <div>
            <div className="font-semibold text-gray-600 mb-1">Proposé</div>
            <pre className="bg-gray-50 p-2 rounded text-[10px] overflow-auto max-h-48">
              {JSON.stringify(proposal.proposed_row, null, 2)}
            </pre>
          </div>
          {proposal.current_row && (
            <div>
              <div className="font-semibold text-gray-600 mb-1">Actuel</div>
              <pre className="bg-gray-50 p-2 rounded text-[10px] overflow-auto max-h-48">
                {JSON.stringify(proposal.current_row, null, 2)}
              </pre>
            </div>
          )}
        </div>
      )}
      <div className="flex justify-end gap-2 mt-2">
        <button onClick={() => onReject(proposal.id)}
          className="inline-flex items-center gap-1 px-2 py-1 text-[10px] rounded border border-gray-300 hover:bg-red-50 text-red-700">
          <FiX className="h-3 w-3" /> Rejeter
        </button>
        <button onClick={() => setConfirmOpen(true)}
          className="inline-flex items-center gap-1 px-2 py-1 text-[10px] rounded bg-green-600 text-white hover:bg-green-700">
          <FiCheck className="h-3 w-3" /> Approuver
        </button>
      </div>

      <ConfirmApproveModal
        open={confirmOpen}
        proposal={proposal}
        onClose={() => setConfirmOpen(false)}
        onConfirm={async (id) => { setConfirmOpen(false); await onApprove(id); }}
      />
    </div>
  );
}
